module.exports = __webpack_public_path__ + "static/img/点击抢券@3x.00c38e4f.png";